import { IDuree } from './duree.i';

export class CDuree implements IDuree {
  id = 0;
  libelle = '';

  constructor(source?: IDuree) {
    if (source) {
      Object.assign(this, {
        id: source.id,
        libelle: source.libelle
      });
    }
  }
}
